module.exports = __webpack_public_path__ + "img/D302.82897ee8.png";